import {
  completeServiceRequestVisit,
  updateServiceRequestData,
  patchServiceRequestPatientField,
  updateRequestDetailsPatients as updateRequestDetailsPatientsRequest,
  updateRequestDetailsCommonInfo as updateRequestDetailsCommonInfoRequest,
} from "queries/request";

export const completeRequest =
  (files, targetRequest, _dataRequest, listRequests) => () =>
    completeServiceRequestVisit(files, targetRequest, listRequests);

export const updateRequestData = (uuid, body) => () =>
  updateServiceRequestData(uuid, body);

export const changeRequestDetails =
  (field, patientUuid, value, requestUuid) => () => {
    patchServiceRequestPatientField(field, patientUuid, value, requestUuid);
  };

export const updateRequestDetailsPatients = (args) => () =>
  updateRequestDetailsPatientsRequest(args);

export const updateRequestDetailsCommonInfo = (args) => () =>
  updateRequestDetailsCommonInfoRequest(args);
